import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576.985 311.216"
    {...props}
  >
    <defs>
      <style>
        {
          ".ad-sensei-1{fill:#fff}.ad-sensei-2{fill:#e9ecef}.ad-sensei-3{fill:#c1c6cb}.ad-sensei-4{fill:#00aeef}.ad-sensei-6{fill:#0fd149}.ad-sensei-7{fill:#efc621}.ad-sensei-8{fill:#1eca8a}.ad-sensei-9{fill:#a8a8b1}"
        }
      </style>
    </defs>
    <g id="Guides_and_Back" data-name="Guides and Back">
      <path
        d="M29.979 29.481c31.534-25.156 74.867 23.8 168.76 35.837C333.414 82.589 377.966-.975 465.887 30.784c81.174 29.322 142.568 136.447 116.233 198.722-16.306 38.559-75.683 51.429-193.771 75.594-145.421 29.759-219.308 43.824-276.922 3.91-51.458-35.649-70.043-93.594-81.2-128.373-7.015-21.88-38.652-120.519-.248-151.156Z"
        transform="translate(-11.317 -22.392)"
      />
      <path className="ad-sensei-1" d="M38.683 27.608h500v250h-500z" />
    </g>
    <g id="Page_Content" data-name="Page Content">
      <rect
        className="ad-sensei-2"
        x={71.183}
        y={81.108}
        width={211}
        height={178}
        rx={3.5}
      />
      <path
        className="ad-sensei-2"
        d="M290 104a3 3 0 0 1 3 3v171a3 3 0 0 1-3 3H86a3 3 0 0 1-3-3V107a3 3 0 0 1 3-3h204m0-1H86a4.012 4.012 0 0 0-4 4v171a4.012 4.012 0 0 0 4 4h204a4.012 4.012 0 0 0 4-4V107a4.012 4.012 0 0 0-4-4Z"
        transform="translate(-11.317 -22.392)"
      />
      <rect
        className="ad-sensei-1"
        x={80.683}
        y={167.608}
        width={196}
        height={48}
        rx={4}
      />
      <path
        className="ad-sensei-3"
        d="M81.032 93.324h59.651v8.64H81.032zM87.032 188.794h59.651v7.405H87.032zM155.032 188.794h16.651v7.405h-16.651zM87.032 201.651h65.993v7.405H87.032zM162.262 201.651h18.421v7.405h-18.421z"
      />
      <path
        className="ad-sensei-4"
        d="M142.032 148.324h27.651v8.64h-27.651zM189.032 148.324h27.651v8.64h-27.651zM236.032 148.324h27.651v8.64h-27.651z"
      />
      <path
        className="ad-sensei-1"
        d="M74.9 46.108h79.056a3.716 3.716 0 0 1 3.716 3.716v15.727a3.715 3.715 0 0 1-3.715 3.715H74.9a3.716 3.716 0 0 1-3.716-3.716V49.824a3.716 3.716 0 0 1 3.716-3.716Z"
      />
      <path
        className="ad-sensei-4"
        d="M165.272 69a3.219 3.219 0 0 1 3.215 3.216v15.727a3.218 3.218 0 0 1-3.215 3.215H86.216A3.219 3.219 0 0 1 83 87.943V72.216A3.22 3.22 0 0 1 86.216 69h79.056m0-1H86.216A4.228 4.228 0 0 0 82 72.216v15.727a4.228 4.228 0 0 0 4.216 4.215h79.056a4.228 4.228 0 0 0 4.215-4.215V72.216A4.228 4.228 0 0 0 165.272 68Z"
        transform="translate(-11.317 -22.392)"
      />
      <rect
        className="ad-sensei-1"
        x={162.899}
        y={46.108}
        width={86.488}
        height={23.159}
        rx={3.716}
      />
      <path
        className="ad-sensei-4"
        d="M256.987 69a3.22 3.22 0 0 1 3.216 3.216v15.727a3.219 3.219 0 0 1-3.216 3.215h-79.056a3.219 3.219 0 0 1-3.216-3.215V72.216A3.22 3.22 0 0 1 177.931 69h79.056m0-1h-79.056a4.228 4.228 0 0 0-4.216 4.216v15.727a4.228 4.228 0 0 0 4.216 4.215h79.056a4.228 4.228 0 0 0 4.216-4.215V72.216A4.228 4.228 0 0 0 256.987 68Z"
        transform="translate(-11.317 -22.392)"
      />
      <rect
        className="ad-sensei-1"
        x={254.614}
        y={46.108}
        width={86.487}
        height={23.159}
        rx={3.716}
      />
      <path
        className="ad-sensei-4"
        d="M348.7 69a3.219 3.219 0 0 1 3.215 3.216v15.727a3.218 3.218 0 0 1-3.215 3.215h-79.054a3.218 3.218 0 0 1-3.215-3.215V72.216A3.219 3.219 0 0 1 269.646 69H348.7m0-1h-79.054a4.228 4.228 0 0 0-4.215 4.216v15.727a4.228 4.228 0 0 0 4.215 4.215H348.7a4.228 4.228 0 0 0 4.215-4.215V72.216A4.228 4.228 0 0 0 348.7 68Z"
        transform="translate(-11.317 -22.392)"
      />
      <rect
        x={383.372}
        y={45.608}
        width={32.311}
        height={24.158}
        rx={4}
        style={{
          fill: "#e8e8ea",
        }}
      />
      <rect
        className="ad-sensei-4"
        x={441.683}
        y={45.608}
        width={65}
        height={24.158}
        rx={4}
      />
      <rect
        className="ad-sensei-4"
        x={176.683}
        y={116.608}
        width={53}
        height={21}
        rx={4}
      />
      <rect
        className="ad-sensei-4"
        x={80.683}
        y={144.608}
        width={53}
        height={16}
        rx={4}
      />
      <rect
        className="ad-sensei-6"
        x={86.683}
        y={172.751}
        width={33}
        height={9.429}
        rx={3.167}
      />
      <rect
        className="ad-sensei-4"
        x={237.683}
        y={200.751}
        width={33}
        height={9.429}
        rx={3.167}
      />
      <rect
        className="ad-sensei-7"
        x={80.683}
        y={116.608}
        width={72}
        height={21}
        rx={4}
      />
      <rect
        className="ad-sensei-8"
        x={346.037}
        y={45.608}
        width={32.311}
        height={24.158}
        rx={4}
      />
      <rect
        className="ad-sensei-8"
        x={234.683}
        y={116.608}
        width={42.664}
        height={21}
        rx={4}
      />
      <path
        className="ad-sensei-4"
        d="m155.759 83.355-3.644-3.6a.625.625 0 0 1 0-.9l.6-.6a.648.648 0 0 1 .909 0l2.586 2.546 2.583-2.549a.648.648 0 0 1 .909 0l.608.6a.625.625 0 0 1 0 .9l-3.644 3.6a.649.649 0 0 1-.912 0Z"
        transform="translate(-11.317 -22.392)"
      />
      <rect
        className="ad-sensei-1"
        x={190.183}
        y={86.108}
        width={86.487}
        height={23.159}
        rx={3.716}
      />
      <path
        className="ad-sensei-4"
        d="M284.272 109a3.219 3.219 0 0 1 3.215 3.216v15.727a3.218 3.218 0 0 1-3.215 3.215h-79.056a3.219 3.219 0 0 1-3.216-3.215v-15.727a3.22 3.22 0 0 1 3.216-3.216h79.056m0-1h-79.056a4.228 4.228 0 0 0-4.216 4.216v15.727a4.228 4.228 0 0 0 4.216 4.215h79.056a4.228 4.228 0 0 0 4.215-4.215v-15.727a4.228 4.228 0 0 0-4.215-4.216Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-4"
        d="m274.759 123.355-3.644-3.6a.625.625 0 0 1 0-.9l.605-.6a.648.648 0 0 1 .909 0l2.586 2.546 2.583-2.549a.648.648 0 0 1 .909 0l.608.6a.625.625 0 0 1 0 .9l-3.644 3.6a.649.649 0 0 1-.912 0ZM247.526 83.355l-3.645-3.6a.625.625 0 0 1 0-.9l.606-.6a.647.647 0 0 1 .908 0l2.587 2.546 2.583-2.549a.647.647 0 0 1 .908 0l.609.6a.625.625 0 0 1 0 .9l-3.645 3.6a.648.648 0 0 1-.911 0ZM339.292 83.355l-3.644-3.6a.625.625 0 0 1 0-.9l.6-.6a.648.648 0 0 1 .909 0l2.586 2.546 2.583-2.549a.648.648 0 0 1 .909 0l.608.6a.625.625 0 0 1 0 .9l-3.644 3.6a.649.649 0 0 1-.912 0Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-9"
        d="M280.82 195.294h-6.882a.932.932 0 0 0-.938.925V203a.932.932 0 0 0 .938.925h6.882a.932.932 0 0 0 .939-.925v-6.779a.932.932 0 0 0-.939-.927Zm0 7.7h-6.882v-6.779h6.882Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-1"
        d="M288 282H92v-33a4.012 4.012 0 0 1 4-4h188a4.012 4.012 0 0 1 4 4Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-3"
        d="M87.032 243.794h59.651v7.405H87.032zM155.032 243.794h16.651v7.405h-16.651zM87.032 256.651h65.993v2.957H87.032zM162.262 256.651h18.421v2.957h-18.421z"
      />
      <rect
        className="ad-sensei-6"
        x={86.683}
        y={227.751}
        width={33}
        height={9.429}
        rx={3.167}
      />
      <path
        className="ad-sensei-9"
        d="M280.82 250.294h-6.882a.932.932 0 0 0-.938.925V258a.932.932 0 0 0 .938.925h6.882a.932.932 0 0 0 .939-.925v-6.779a.932.932 0 0 0-.939-.927Zm0 7.7h-6.882v-6.779h6.882Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-6"
        d="M150.261 197h-14.787a.474.474 0 0 0-.474.474v4.735a.474.474 0 0 0 .474.474h14.787a.474.474 0 0 0 .474-.474v-4.735a.474.474 0 0 0-.474-.474Zm-.474 4.736h-13.84v-3.789h13.842v3.789Z"
        transform="translate(-11.317 -22.392)"
      />
      <path className="ad-sensei-6" d="M125.37 176.295h10.388v2.309H125.37z" />
      <path
        className="ad-sensei-7"
        d="M150.3 252.065h-14.825a.475.475 0 0 0-.475.475v4.747a.474.474 0 0 0 .475.474H150.3a.474.474 0 0 0 .474-.474v-4.747a.475.475 0 0 0-.474-.475Zm-.475 4.747h-13.876v-3.8h13.873v3.8Z"
        transform="translate(-11.317 -22.392)"
      />
      <path className="ad-sensei-7" d="M125.374 231.364h6.194v2.314h-6.194z" />
      <rect
        className="ad-sensei-2"
        x={295.183}
        y={81.108}
        width={211}
        height={178}
        rx={3.5}
      />
      <path
        className="ad-sensei-2"
        d="M514 104a3 3 0 0 1 3 3v171a3 3 0 0 1-3 3H310a3 3 0 0 1-3-3V107a3 3 0 0 1 3-3h204m0-1H310a4.012 4.012 0 0 0-4 4v171a4.012 4.012 0 0 0 4 4h204a4.012 4.012 0 0 0 4-4V107a4.012 4.012 0 0 0-4-4Z"
        transform="translate(-11.317 -22.392)"
      />
      <rect
        className="ad-sensei-1"
        x={304.683}
        y={167.608}
        width={196}
        height={48}
        rx={4}
      />
      <path
        className="ad-sensei-3"
        d="M305.032 93.324h59.651v8.64h-59.651zM311.032 188.794h59.651v7.405h-59.651zM379.032 188.794h16.651v7.405h-16.651zM311.032 201.651h65.993v7.405h-65.993zM386.262 201.651h18.421v7.405h-18.421z"
      />
      <path
        className="ad-sensei-4"
        d="M366.032 148.324h27.651v8.64h-27.651zM413.032 148.324h27.651v8.64h-27.651zM460.032 148.324h27.651v8.64h-27.651z"
      />
      <rect
        className="ad-sensei-4"
        x={400.683}
        y={116.608}
        width={53}
        height={21}
        rx={4}
      />
      <rect
        className="ad-sensei-4"
        x={304.683}
        y={144.608}
        width={53}
        height={16}
        rx={4}
      />
      <rect
        className="ad-sensei-7"
        x={310.683}
        y={172.751}
        width={33}
        height={9.429}
        rx={3.167}
      />
      <rect
        className="ad-sensei-7"
        x={304.683}
        y={116.608}
        width={72}
        height={21}
        rx={4}
      />
      <rect
        className="ad-sensei-8"
        x={458.683}
        y={116.608}
        width={42.664}
        height={21}
        rx={4}
      />
      <rect
        className="ad-sensei-1"
        x={414.183}
        y={86.108}
        width={86.487}
        height={23.159}
        rx={3.716}
      />
      <path
        className="ad-sensei-4"
        d="M508.272 109a3.219 3.219 0 0 1 3.215 3.216v15.727a3.218 3.218 0 0 1-3.215 3.215h-79.056a3.219 3.219 0 0 1-3.216-3.215v-15.727a3.22 3.22 0 0 1 3.216-3.216h79.056m0-1h-79.056a4.228 4.228 0 0 0-4.216 4.216v15.727a4.228 4.228 0 0 0 4.216 4.215h79.056a4.228 4.228 0 0 0 4.215-4.215v-15.727a4.228 4.228 0 0 0-4.215-4.216Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-4"
        d="m498.759 123.355-3.644-3.6a.625.625 0 0 1 0-.9l.605-.6a.648.648 0 0 1 .909 0l2.586 2.546 2.583-2.549a.648.648 0 0 1 .909 0l.608.6a.625.625 0 0 1 0 .9l-3.644 3.6a.649.649 0 0 1-.912 0Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-9"
        d="M504.82 195.294h-6.882a.932.932 0 0 0-.938.925V203a.932.932 0 0 0 .938.925h6.882a.932.932 0 0 0 .939-.925v-6.779a.932.932 0 0 0-.939-.927Zm0 7.7h-6.882v-6.779h6.882Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-1"
        d="M512 282H316v-33a4.012 4.012 0 0 1 4-4h188a4.012 4.012 0 0 1 4 4Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-3"
        d="M311.032 243.794h59.651v7.405h-59.651zM379.032 243.794h16.651v7.405h-16.651zM311.032 256.651h65.993v2.957h-65.993zM386.262 256.651h18.421v2.957h-18.421z"
      />
      <rect
        x={310.683}
        y={227.751}
        width={33}
        height={9.429}
        rx={3.167}
        style={{
          fill: "#f93b7a",
        }}
      />
      <path
        className="ad-sensei-9"
        d="M504.82 250.294h-6.882a.932.932 0 0 0-.938.925V258a.932.932 0 0 0 .938.925h6.882a.932.932 0 0 0 .939-.925v-6.779a.932.932 0 0 0-.939-.927Zm0 7.7h-6.882v-6.779h6.882Z"
        transform="translate(-11.317 -22.392)"
      />
      <path
        className="ad-sensei-4"
        d="M282 282h-33v-1.69a3.167 3.167 0 0 1 3.167-3.167h26.666A3.176 3.176 0 0 1 282 280.31Z"
        transform="translate(-11.317 -22.392)"
      />
      <rect
        className="ad-sensei-4"
        x={461.683}
        y={200.751}
        width={33}
        height={9.429}
        rx={3.167}
      />
      <path
        className="ad-sensei-4"
        d="M506 282h-33v-1.69a3.167 3.167 0 0 1 3.167-3.167h26.666A3.176 3.176 0 0 1 506 280.31Z"
        transform="translate(-11.317 -22.392)"
      />
    </g>
  </svg>
)

export default SvgComponent
